import { enableLog } from './tools'

export const numberConditions = {
  '>': (a: number, b: number) => a > b,
  '<': (a: number, b: number) => a < b,
  '=': (a: number, b: number) => a === b,
  '>=': (a: number, b: number) => a >= b,
  '<=': (a: number, b: number) => a <= b,
}

export const getNumberConditions = (
  content: {
    group: any[]
    options: any[]
    is_jump: boolean
  },
  position_id?: number
) => {
  const { is_jump, group } = content
  if (!position_id || !is_jump) return {}
  // 获取当前选项的分数
  const option = content.options.find((item) => item.position_id === position_id)
  const currentScore = option.score
  // 找到第一个符合的group
  const target =
    group.find((item: any) => {
      const { from, left } = item
      // 找到from的数字
      const score = content.options.find((item) => item.position_id === from)?.score
      if (!score) return false
      // 执行
      return numberConditions[left as keyof typeof numberConditions](currentScore, score)
    }) ?? {}
  const { right, to } = target
  if (right && to) {
    return {
      [right]: to,
    }
  }
  return {}
}

export const getChoiceConditions = (
  content: {
    group: any[]
    options: any[]
    is_jump: boolean
  },
  choice?: number[]
) => {
  const { is_jump, group } = content
  if (enableLog()) {
    console.log('content', content)
  }
  if (!choice || !is_jump) return {}
  const position_ids = choice
  // 找到第一个符合的group
  // ps： 这里不一定，可能是多个，如果是多选的话就会出现这个问题，应当在源头处理
  const target = group.filter((item: any) => {
    const { from } = item
    return position_ids.includes(from)
  })
  if (!target) return {}
  const data = target.reduce((pre, cur) => {
    const { right, to } = cur
    if (right && to) {
      return {
        ...pre,
        [right]: to,
      }
    }
    return pre
  }, {})
  return data
}
